import React from 'react';
//import Accordion2 from '../components/Accordion2/accordion2';

const Foodiary=()=>{
    var giornatatipo=["GIORNATA TIPO 1", "GIORNATA TIPO 2"];
    var contenutotipo=["CONTENUTO TIPO 1","CONTENUTO TIPO 2"];
    return(
        <div>
            <h3>DIARIO ALIMENTARE</h3>
            <div className="jumbotron"><h4>Coming soon...</h4></div>
            {            /*
            {giornatatipo.map((giorno, key)=>(
                <Accordion2 title={giorno} content={contenutotipo[key]}/>
            ))}*/}
        </div>
    )
}
export default Foodiary;